import PropTypes from 'prop-types'
import React from 'react'

const SearchResultFlightInformation = ({
  classes,
  departureAirport,
  arrivalAirport,
  departureDate,
}) => {
  return (
    <header className={classes.header}>
      <h2
        className={classes.title}
      >{`${departureAirport} - ${arrivalAirport}`}</h2>
      <time className={classes.time}>{departureDate}</time>
    </header>
  )
}

SearchResultFlightInformation.propTypes = {
  classes: PropTypes.shape({
    header: PropTypes.string,
    title: PropTypes.string,
    time: PropTypes.string,
  }),
  departureAirport: PropTypes.string,
  departureDate: PropTypes.string,
  arrivalAirport: PropTypes.string,
}

export default SearchResultFlightInformation
